module.exports = __webpack_public_path__ + "static/img/12.a1fd864.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting596/images/12.png
// module id = dujA
// module chunks = 4